import { lockScroll } from './utility';

const { lock, unlock } = lockScroll();

class DrawerMenu {
  constructor(parentElement, triggerButton, menu, overlay) {
    this.parentElement = parentElement;
    this.triggerButton = triggerButton;
    this.menu = menu;
    this.overlay = overlay; // オーバーレイを指定
    this.isExpanded = false;
    this.setupOverlayListener(); // オーバーレイのイベントリスナーを設定
  }

  // メニュー表示処理
  showMenu() {
    if (!this.isExpanded) {
      this.isExpanded = true;
      this.triggerButton.setAttribute('aria-expanded', this.isExpanded);
      this.menu.setAttribute('aria-hidden', !this.isExpanded);
      this.overlay.classList.add('is-show'); // オーバーレイを表示
      lock(); // スクロールロックを有効化
    }
  }

  // メニュー非表示処理
  hideMenu() {
    if (this.isExpanded) {
      this.isExpanded = false;
      this.triggerButton.setAttribute('aria-expanded', this.isExpanded);
      this.menu.setAttribute('aria-hidden', !this.isExpanded);
      this.overlay.classList.remove('is-show'); // オーバーレイを非表示
      unlock(); // スクロールロックを解除
    }
  }

  // オーバーレイに対するイベントリスナーを設定
  setupOverlayListener() {
    this.overlay.addEventListener('mouseenter', () => this.hideMenu());
  }

  // ホバーイベントリスナー設定
  handleHover() {
    this.parentElement.addEventListener('mouseenter', () => this.showMenu());
    this.parentElement.addEventListener('mouseleave', () => this.hideMenu());
  }
}

// DrawerMenu インスタンスの初期化
export const drawerMenu = () => {
  const drawerElements = document.querySelectorAll('.js-drawer');
  drawerElements.forEach((drawerElement) => {
    const triggerButton = drawerElement.querySelector('.js-drawer-trigger');
    const menu = drawerElement.querySelector('.js-drawer-menu');
    const overlay = drawerElement.querySelector('.js-overlay'); // オーバーレイを取得
    if (triggerButton && menu && overlay) {
      const drawerInstance = new DrawerMenu(drawerElement, triggerButton, menu, overlay);
      drawerInstance.handleHover();
    }
  });
};
